// SalmanOS icons: Phosphor Icons (MIT, phosphoricons.com), one professional family drawn on a 256-unit grid, inlined
// as SVG so they stay sharp at any pixel density and take the theme colour (currentColor). Regular weight for the
// interface, duotone for the app tiles and feature marks.
import userCircle from '@phosphor-icons/core/assets/duotone/user-circle-duotone.svg?raw';
import path from '@phosphor-icons/core/assets/duotone/path-duotone.svg?raw';
import squaresFour from '@phosphor-icons/core/assets/duotone/squares-four-duotone.svg?raw';
import briefcase from '@phosphor-icons/core/assets/duotone/briefcase-duotone.svg?raw';
import calendarCheck from '@phosphor-icons/core/assets/duotone/calendar-check-duotone.svg?raw';
import fileText from '@phosphor-icons/core/assets/duotone/file-text-duotone.svg?raw';
import paperPlane from '@phosphor-icons/core/assets/duotone/paper-plane-tilt-duotone.svg?raw';
import stack from '@phosphor-icons/core/assets/duotone/stack-duotone.svg?raw';
import images from '@phosphor-icons/core/assets/duotone/images-duotone.svg?raw';
import terminal from '@phosphor-icons/core/assets/duotone/terminal-window-duotone.svg?raw';
import storefront from '@phosphor-icons/core/assets/duotone/storefront-duotone.svg?raw';
import robot from '@phosphor-icons/core/assets/duotone/robot-duotone.svg?raw';
import cubeFocus from '@phosphor-icons/core/assets/duotone/cube-focus-duotone.svg?raw';
import graduationCap from '@phosphor-icons/core/assets/duotone/graduation-cap-duotone.svg?raw';
import soccer from '@phosphor-icons/core/assets/duotone/soccer-ball-duotone.svg?raw';
import gearSix from '@phosphor-icons/core/assets/duotone/gear-six-duotone.svg?raw';
import browsers from '@phosphor-icons/core/assets/duotone/browsers-duotone.svg?raw';
import discord from '@phosphor-icons/core/assets/duotone/discord-logo-duotone.svg?raw';
import telegram from '@phosphor-icons/core/assets/duotone/telegram-logo-duotone.svg?raw';
import deviceMobile from '@phosphor-icons/core/assets/duotone/device-mobile-duotone.svg?raw';
import kanban from '@phosphor-icons/core/assets/duotone/kanban-duotone.svg?raw';
import rocket from '@phosphor-icons/core/assets/duotone/rocket-launch-duotone.svg?raw';
import lifebuoy from '@phosphor-icons/core/assets/duotone/lifebuoy-duotone.svg?raw';
import handshake from '@phosphor-icons/core/assets/duotone/handshake-duotone.svg?raw';
import trophy from '@phosphor-icons/core/assets/duotone/trophy-duotone.svg?raw';
import student from '@phosphor-icons/core/assets/duotone/student-duotone.svg?raw';
import flagBanner from '@phosphor-icons/core/assets/duotone/flag-banner-duotone.svg?raw';
import codeD from '@phosphor-icons/core/assets/duotone/code-duotone.svg?raw';
import lightningD from '@phosphor-icons/core/assets/duotone/lightning-duotone.svg?raw';
import targetD from '@phosphor-icons/core/assets/duotone/target-duotone.svg?raw';
import sealCheck from '@phosphor-icons/core/assets/duotone/seal-check-duotone.svg?raw';
import hourglass from '@phosphor-icons/core/assets/duotone/hourglass-medium-duotone.svg?raw';
import chatDots from '@phosphor-icons/core/assets/duotone/chat-circle-dots-duotone.svg?raw';
import x from '@phosphor-icons/core/assets/regular/x.svg?raw';
import minus from '@phosphor-icons/core/assets/regular/minus.svg?raw';
import cornersOut from '@phosphor-icons/core/assets/regular/corners-out.svg?raw';
import cornersIn from '@phosphor-icons/core/assets/regular/corners-in.svg?raw';
import speakerHigh from '@phosphor-icons/core/assets/regular/speaker-high.svg?raw';
import speakerSlash from '@phosphor-icons/core/assets/regular/speaker-slash.svg?raw';
import sun from '@phosphor-icons/core/assets/regular/sun.svg?raw';
import moon from '@phosphor-icons/core/assets/regular/moon.svg?raw';
import power from '@phosphor-icons/core/assets/regular/power.svg?raw';
import arrowUpRight from '@phosphor-icons/core/assets/regular/arrow-up-right.svg?raw';
import githubLogo from '@phosphor-icons/core/assets/regular/github-logo.svg?raw';
import whatsappLogo from '@phosphor-icons/core/assets/regular/whatsapp-logo.svg?raw';
import envelope from '@phosphor-icons/core/assets/regular/envelope-simple.svg?raw';
import copy from '@phosphor-icons/core/assets/regular/copy.svg?raw';
import check from '@phosphor-icons/core/assets/regular/check.svg?raw';
import mapPin from '@phosphor-icons/core/assets/regular/map-pin.svg?raw';
import download from '@phosphor-icons/core/assets/regular/download-simple.svg?raw';
import arrowLeft from '@phosphor-icons/core/assets/regular/arrow-left.svg?raw';
import caretRight from '@phosphor-icons/core/assets/regular/caret-right.svg?raw';
import clock from '@phosphor-icons/core/assets/regular/clock.svg?raw';
import house from '@phosphor-icons/core/assets/regular/house.svg?raw';
import githubTile from '@phosphor-icons/core/assets/duotone/github-logo-duotone.svg?raw';
import lock from '@phosphor-icons/core/assets/regular/lock-simple.svg?raw';
import arrowRight from '@phosphor-icons/core/assets/regular/arrow-right.svg?raw';
import reload from '@phosphor-icons/core/assets/regular/arrow-clockwise.svg?raw';
import search from '@phosphor-icons/core/assets/regular/magnifying-glass.svg?raw';
import bell from '@phosphor-icons/core/assets/regular/bell-simple.svg?raw';
import wifi from '@phosphor-icons/core/assets/regular/wifi-high.svg?raw';
import battery from '@phosphor-icons/core/assets/regular/battery-high.svg?raw';
import command from '@phosphor-icons/core/assets/regular/command.svg?raw';
import play from '@phosphor-icons/core/assets/regular/play.svg?raw';
import restart from '@phosphor-icons/core/assets/regular/arrow-counter-clockwise.svg?raw';
import sparkle from '@phosphor-icons/core/assets/regular/sparkle.svg?raw';
import lightning from '@phosphor-icons/core/assets/regular/lightning.svg?raw';
import code from '@phosphor-icons/core/assets/regular/code.svg?raw';
import gear from '@phosphor-icons/core/assets/regular/gear-six.svg?raw';
import palette from '@phosphor-icons/core/assets/regular/palette.svg?raw';
import monitor from '@phosphor-icons/core/assets/regular/monitor.svg?raw';
import globe from '@phosphor-icons/core/assets/regular/globe-simple.svg?raw';
import target from '@phosphor-icons/core/assets/regular/target.svg?raw';
import users from '@phosphor-icons/core/assets/regular/users-three.svg?raw';

export const ICONS = {
  about: userCircle, career: path, projects: squaresFour, services: briefcase, work: calendarCheck, resume: fileText,
  contact: paperPlane, skills: stack, gallery: images, terminal, storefront, robot, 'cube-focus': cubeFocus, 'stack': stack, 'path': path,
  education: graduationCap, football: soccer, settings: gearSix, browsers, discord, telegram, mobile: deviceMobile, kanban, rocket,
  lifebuoy, handshake, trophy, student, flag: flagBanner, codeTile: codeD, bolt: lightningD, targetTile: targetD, seal: sealCheck,
  hourglass, chat: chatDots,
  x, minus, cornersOut, cornersIn, speakerHigh, speakerSlash, sun, moon, power, arrowUpRight, github: githubLogo, whatsapp: whatsappLogo,
  envelope, copy, check, mapPin, download, arrowLeft, caretRight, clock, house, githubTile, lock, arrowRight, reload,
  search, bell, wifi, battery, command, play, restart, sparkle, lightning, code, gear, palette, monitor, globe, target, users,
} as const;
export type IconName = keyof typeof ICONS;

/** An inline icon; decorative unless given a label. */
export function icon(name: IconName, cls = '', label = '') {
  const svg = ICONS[name].replace('<svg ', `<svg class="ic ${cls}" ${label ? `role="img" aria-label="${label}"` : 'aria-hidden="true" focusable="false"'} `);
  return svg;
}
